/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_details__expense_note_section__identity = /** @type {(inputs: {}) => string} */ () => {
	return `Antragsteller`
};

const en_route_details__expense_note_section__identity = /** @type {(inputs: {}) => string} */ () => {
	return `Applicant`
};

const es_route_details__expense_note_section__identity = /** @type {(inputs: {}) => string} */ () => {
	return `Solicitante`
};

const fr_route_details__expense_note_section__identity = /** @type {(inputs: {}) => string} */ () => {
	return `Demandeur`
};

const it_route_details__expense_note_section__identity = /** @type {(inputs: {}) => string} */ () => {
	return `Richiedente`
};

const nl_route_details__expense_note_section__identity = /** @type {(inputs: {}) => string} */ () => {
	return `Aanvrager`
};

const pt_route_details__expense_note_section__identity = /** @type {(inputs: {}) => string} */ () => {
	return `Requerente`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__identity = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_details__expense_note_section__identity(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_details__expense_note_section__identity", locale)
	if (locale === "de") return de_route_details__expense_note_section__identity(inputs)
	if (locale === "en") return en_route_details__expense_note_section__identity(inputs)
	if (locale === "es") return es_route_details__expense_note_section__identity(inputs)
	if (locale === "fr") return fr_route_details__expense_note_section__identity(inputs)
	if (locale === "it") return it_route_details__expense_note_section__identity(inputs)
	if (locale === "nl") return nl_route_details__expense_note_section__identity(inputs)
	return pt_route_details__expense_note_section__identity(inputs)
};